import React from "react";
import "./pagefooter.css";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>
          Contact Best Physiotherapy in  Udupi & No. 1 Rehab Center | AIKYAM
        </title>
        <meta
          name="description"
          content="Contact AIKYAM Sports Science, Udupi's No. 1 rated clinic for the best sports physiotherapy, athlete performance testing, rehabilitation, and elite strength & conditioning."
        />
        <meta
          name="keywords"
          content="Contact best physiotherapist udupi, No 1 sports rehab udupi, Top rated physiotherapy clinic manipal, best S&C coaches mangalore, AIKYAM Sports Science contact"
        />
        <link rel="canonical" href="https://aikyamsports.com/contact" />
        <meta property="og:title" content="Contact Udupi's Best Physiotherapy & No. 1 Rehab Center | AIKYAM" />
        <meta property="og:description" content="Get in touch with the No. 1 rated AIKYAM Sports Science for the best sports physiotherapy and rehabilitation in Udupi." />
        <meta property="og:url" content="https://aikyamsports.com/contact" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://aikyamsports.com/logo11.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Udupi's Best Physiotherapy & No. 1 Rehab Center" />
        <meta name="twitter:description" content="Contact the best sports science and top-rated physiotherapy center in Udupi, Karnataka." />
        <meta name="twitter:image" content="https://aikyamsports.com/logo11.png" />
      </Helmet>

      <div className="policy-page">
        <h1>Contact Udupi's Best Sports Science & Rehab Center</h1>

        <p>
          Whether you're an athlete, coach, academy, or fitness enthusiast, our team is here to help you improve performance at the <strong>No. 1 rated</strong> facility in Udupi for science-backed training, top-tier rehabilitation, and advanced sports technology.
        </p>

        <h2>Contact Information</h2>

        <ul>
          <li><strong>📞 Phone:</strong> +91 6363202281</li>
          <li><strong>📞 Alternate:</strong> +91 7019386664</li>
          <li>
            <strong>📧 Email:</strong>{" "}
            <a href="mailto:aikyamsports@gmail.com">aikyamsports@gmail.com</a>
          </li>
          <li>
            <strong>📍 Address:</strong>
            <br />
            Center for Sports Science
            <br />
            Mahatma Gandhi Stadium
            <br />
            Ajjarakad, Brahmagiri
            <br />
            Udupi, Karnataka – 576101
          </li>
        </ul>

        <h2>Business Hours</h2>
        <ul>
          <li>Monday – Saturday: 5:30 - 11:00 AM | 3:00 - 7:30 PM</li>
          <li>Sunday: By Appointment</li>
        </ul>

        <h2>Our Top-Rated Services</h2>
        <ul>
          <li>Best Physiotherapy in Udupi</li>
          <li>Best Sports Science Assessment</li>
          <li>Top-tier Athlete Performance Testing</li>
          <li>Elite Strength & Conditioning</li>
          <li>Best-in-class Sports Rehabilitation</li>
          <li>Clinical Sports Nutrition</li>
          <li>Sports Psychology</li>
          <li>Group Fitness Programs</li>
        </ul>

        <h2>Who We Work With</h2>
        <p>
          We proudly work with athletes, coaches, sports academies, schools, and colleges seeking the best rehabilitation and fitness professionals across Udupi, Manipal, Mangalore, and throughout India.
        </p>

        <h2>Visit Our No. 1 Rated Centre</h2>
        <p>
          Located in the heart of Udupi, our facility is recognized as the best combination of sports science, physiotherapy, and cutting-edge performance technology to help you recover faster and train smarter.
        </p>

        <h2>Need Help?</h2>
        <p>
          Our top-rated team usually responds to enquiries within <strong>24 hours</strong>. Contact us for:
        </p>
        <ul>
          <li>Physiotherapy Appointments</li>
          <li>Performance Testing</li>
          <li>Timing Gate Demonstrations</li>
          <li>Academy Assessments</li>
        </ul>
      </div>
    </>
  );
};

export default Contact;